import React, { createContext, useContext, useMemo } from "react";

interface TabParamsContextValue {
  params: Record<string, string>;
}

const TabParamsContext = createContext<TabParamsContextValue>({ params: {} });

export function TabParamsProvider({ 
  children, 
  params 
}: { 
  children: React.ReactNode; 
  params: Record<string, string>;
}) {
  const value = useMemo(() => ({ params }), [params]);
  
  return (
    <TabParamsContext.Provider value={value}>
      {children}
    </TabParamsContext.Provider>
  );
}

export function useTabParam(key: string): string | undefined {
  return useContext(TabParamsContext).params[key];
}
